import { motion } from "framer-motion";

/**
 * Light-theme animated progress bar — soft track + green progress.
 * Typography rule: title uses navy, % uses pure black.
 */
export default function AnimatedProgressBar({ progress = 72 }) {
  return (
    <div className="w-full" data-testid="landing-progress-bar">
      <div className="flex items-center justify-between mb-3">
        <span className="text-[10px] sm:text-xs uppercase tracking-[0.3em] font-bold text-brand-green">
          Lancement imminent
        </span>
        <motion.span
          className="text-[10px] sm:text-xs uppercase tracking-[0.25em] font-bold text-black"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          data-testid="progress-percentage"
        >
          {progress}%
        </motion.span>
      </div>
      <div className="relative h-[6px] w-full overflow-hidden rounded-full bg-brand-navy/10 border border-brand-navy/10">
        <motion.div
          className="h-full rounded-full bg-gradient-to-r from-brand-blue via-brand-lightBlue to-brand-green"
          initial={{ width: "0%" }}
          animate={{ width: `${progress}%` }}
          transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
        />
        <motion.div
          className="absolute inset-y-0 w-1/3 bg-gradient-to-r from-transparent via-white/70 to-transparent"
          initial={{ x: "-100%" }}
          animate={{ x: "300%" }}
          transition={{ duration: 2.6, repeat: Infinity, ease: "linear" }}
        />
      </div>
    </div>
  );
}
